import { Address, generateAddressFG } from './address.model';
import { Phone } from './phone.model';
import { Document } from './document.model';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';

export interface Representative {
    nombre: string;
    apellido: string;
    cargo: 'APODERADO' | 'OTROS';
    fechaNacimiento: string;
    fechaPoder?: string;
    poderAdjunto?: Document;
    nombreCargo?: string;
    nroAsambleaEstatuto?: string;
    mail?: string;
    celular?: Phone;
    dni?: string;
    direccion?: Address;
}

export function generateRepresentativeFG() {
    return new UntypedFormGroup({
        tieneRepresentante: new UntypedFormControl(false, []),
        nombre: new UntypedFormControl('', [Validators.required]),
        apellido: new UntypedFormControl('', [Validators.required]),
        fechaNacimiento: new UntypedFormControl('', [Validators.required]),
        cargo: new UntypedFormControl('', [Validators.required]),
        fechaPoder: new UntypedFormControl('', [Validators.required]),
        poderAdjunto: new UntypedFormControl('', [Validators.required]),
        nombreCargo: new UntypedFormControl('', []),
        nroAsambleaEstatuto: new UntypedFormControl('', []),
        mail: new UntypedFormControl('', [Validators.required]),
        dni: new UntypedFormControl('', [Validators.required]),
        celular: new UntypedFormControl('', [Validators.required]),
        direccion: generateAddressFG()
    });
}
